import React from "react";
import { buildMetricsRow } from "./heroUtils";

const BUILDING_ICON = '/assets/images/commercialPDP/Icon.png';

/**
 * HeroPropertyInfo displays the property category badge, name, address,
 * and commercial metrics row in the hero section overlay.
 */
const HeroPropertyInfo = ({
  categoryLabel,
  propertyName,
  address,
  squareFeet,
  tenantCount,
  occupancyPercentage,
  isLand,
  lotSize,
  lotSizeUnit,
}) => {
  const metrics = buildMetricsRow(squareFeet, tenantCount, occupancyPercentage, isLand, lotSize, lotSizeUnit);

  const formatAddress = (addr) => {
    if (!addr) return "";
    const { streetNumber, streetName, city, state, zip } = addr;
    const street = [streetNumber, streetName].filter(Boolean).join(" ");
    const cityState = [city, state].filter(Boolean).join(", ");
    const parts = [street, cityState].filter(Boolean);
    if (zip) parts.push(zip);
    return parts.join(", ").replace(`, ${zip}`, ` ${zip}`);
  };
 
  return (
    <div className="commercial-hero__property-info">
      {categoryLabel && (
        <span className="commercial-hero__property-info-badge">
          {categoryLabel}
        </span>
      )}

      {propertyName && (
        <h1 className="commercial-hero__property-info-name">{propertyName}</h1>
      )}

      {address && (
        <p className="commercial-hero__property-info-address">
          {formatAddress(address)}
        </p>
      )}

      {metrics.length > 0 && (
        <div className="commercial-hero__property-info-metrics">
          {metrics.map((metric, index) => (
            <React.Fragment key={metric.type}>
              {index > 0 && (
                <span className="commercial-hero__property-info-metrics-separator" />
              )}
              {metric.type === "sqft"  ? 
                <img src={BUILDING_ICON} alt="" style={{ width: 16, height: 16, marginRight: 4 }} aria-hidden="true" />
              : 

              metrics.length === 1 ? 
              <span className="commercial-hero__property-info-metrics-separator"/>
              :""
              
              }
              <span>{metric.value}</span>
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default HeroPropertyInfo;
